/*
 * Small color utilities used by the widget's theming. The only site-provided
 * theme value is the primary color; its translucent "light" variant is just
 * that color at 5% opacity (#RRGGBB0D). Everything else about the theme is a
 * fixed part of the widget's look.
 */

const DEFAULT_PRIMARY = "#f26322"; // YIPL signature orange

export function normalizeHexColor(value, fallback = DEFAULT_PRIMARY) {
  const input = String(value || "").trim();
  if (/^#[0-9a-fA-F]{3}$/.test(input)) {
    const r = input.charAt(1);
    const g = input.charAt(2);
    const b = input.charAt(3);
    return ("#" + r + r + g + g + b + b).toLowerCase();
  }
  if (/^#[0-9a-fA-F]{6}$/.test(input)) {
    return input.toLowerCase();
  }
  return String(fallback || DEFAULT_PRIMARY).toLowerCase();
}

export function hexToRgb(hex, fallback = DEFAULT_PRIMARY) {
  const normalized = normalizeHexColor(hex, fallback);
  return {
    r: parseInt(normalized.slice(1, 3), 16),
    g: parseInt(normalized.slice(3, 5), 16),
    b: parseInt(normalized.slice(5, 7), 16),
  };
}

export function rgbToHex(rgb) {
  const r = Math.min(255, Math.max(0, Math.round(rgb.r)));
  const g = Math.min(255, Math.max(0, Math.round(rgb.g)));
  const b = Math.min(255, Math.max(0, Math.round(rgb.b)));
  return (
    "#" +
    [r, g, b]
      .map((channel) => channel.toString(16).padStart(2, "0"))
      .join("")
  );
}

export function toRgba(hex, alpha) {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}